module.exports = __webpack_public_path__ + "img/swiper_08.d833c1d1.jpg";